module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/example-5-345adad9079dec997596f435884f54c2.png";